import z from "zod";

const translationPath = "page.4uBus.register.iProcesse.errors.";

export const iProcesseSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  name: z.string().min(1, translationPath + "processe_name"),
  description: z.string().nullish(),
  code: z.number().optional(),
});

export type TIProcesseForm = z.infer<typeof iProcesseSchema>;
